import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "CampaignEditorLeftColumn" }
const _hoisted_2 = {
  ref: "listingBudgetTooltipWrapper",
  class: "TooltipWrapper"
}
const _hoisted_3 = { class: "CampaignEditorRightColumn" }
const _hoisted_4 = {
  key: 0,
  class: "InputDetailsMessage InputDetailsDisabledMessage"
}
const _hoisted_5 = { class: "CampaignEditorLeftColumn" }
const _hoisted_6 = {
  ref: "customProductsBudgetTooltipWrapper",
  class: "TooltipWrapper"
}
const _hoisted_7 = { class: "CampaignEditorRightColumn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Budget = _resolveComponent("Budget")!
  const _component_Currency = _resolveComponent("Currency")!
  const _component_LoadingWrapper = _resolveComponent("LoadingWrapper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_LoadingWrapper, {
      classes: [
			'CampaignEditorRow',
			'BudgetRow',
		],
      isLoading: _ctx.isLoading
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("label", {
            class: _normalizeClass([
				'CampaignEditorInputLabel',
				'DropdownLabel',
				{ 'CampaignSettingsInputRequired': !_ctx.isListingBudgetFieldDisabled },
				{ 'CampaignEditorInputLabelDisable': _ctx.isListingBudgetFieldDisabled },
				{ 'ContentInvalid': _ctx.isListingFieldValidatedAndMissing || _ctx.isListingFieldValidatedAndInvalid }
			])
          }, [
            _cache[1] || (_cache[1] = _createTextVNode(" Listing budget ", -1 /* CACHED */)),
            _createElementVNode("span", _hoisted_2, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("i", { class: "lnr-notification-circle" }, null, -1 /* CACHED */)
            ]))], 512 /* NEED_PATCH */)
          ], 2 /* CLASS */)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Budget, { type: _ctx.budgetTypeListing }, null, 8 /* PROPS */, ["type"]),
          _createVNode(_component_Currency),
          _createElementVNode("div", {
            class: _normalizeClass([
				'ValidationMessage',
				{ 'ContentInvalid': _ctx.isListingFieldValidatedAndMissing || _ctx.isListingFieldValidatedAndInvalid }
			])
          }, _toDisplayString(_ctx.validationMessage), 3 /* TEXT, CLASS */),
          (!_ctx.isListingFieldValidatedAndMissing && !_ctx.isListingFieldValidatedAndInvalid && _ctx.listingBudgetDisabledMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.listingBudgetDisabledMessage), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["isLoading"]),
    _createVNode(_component_LoadingWrapper, {
      classes: [
			'CampaignEditorRow',
			'BudgetRow',
		],
      isLoading: _ctx.isLoading
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", {
            class: _normalizeClass([
				'CampaignEditorInputLabel',
				'DropdownLabel',
				{ 'CampaignSettingsInputRequired': !_ctx.isListingBudgetFieldDisabled },
				{ 'ContentInvalid': _ctx.isCustomFieldValidatedAndMissing || _ctx.isCustomFieldValidatedAndInvalid }
			])
          }, [
            _cache[3] || (_cache[3] = _createTextVNode(" Custom products budget ", -1 /* CACHED */)),
            _createElementVNode("span", _hoisted_6, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("i", { class: "lnr-notification-circle" }, null, -1 /* CACHED */)
            ]))], 512 /* NEED_PATCH */)
          ], 2 /* CLASS */)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Budget, { type: _ctx.budgetTypeCustom }, null, 8 /* PROPS */, ["type"])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["isLoading"])
  ], 64 /* STABLE_FRAGMENT */))
}